import Ease from '@CS/utils/Easing';
import { Screen } from '@CS/app/App.styles';
import styled, { css } from 'styled-components';

const TRANSITION_DURATION = 500;
export const FADE_DURATION = TRANSITION_DURATION - 100;

type PopupOverlayAttributes = {
  opacity: number | string;
  visible: boolean;
  overlay: boolean;
};

export const PopupOverlay = styled.aside(
  ({ visible, overlay, opacity }: PopupOverlayAttributes) => css`
    transition: background-color ${FADE_DURATION}ms;
    background-color: rgb(53 53 53 / 0);
    position: fixed;

    height: 100%;
    width: 100%;

    z-index: 10;
    padding: 0;
    margin: 0;

    bottom: 0;
    right: 0;
    left: 0;
    top: 0;

    ${visible &&
    css`
      ${overlay &&
      css`
        background-color: rgb(53 53 53 / ${opacity});
      `}

      > dialog {
        transition-timing-function: ${Ease.Out.Sine};
        transform: translate(-50%, -50%) scale(1);
        transition-delay: 0s;
        opacity: 1;
      }
    `}
  `
);

const BACKGROUND_COLOR = 'white';
const OPACITY_DURATION = TRANSITION_DURATION * 0.5;
export const CLOSE_SIZE = 'clamp(20px, 6.667vmin, 30px)';

type PopupContainerAttributes = {
  width?: number | string;
  fullScreen?: boolean;
  background?: string;
};

export const PopupContainer = styled.dialog(
  ({ fullScreen, width }: PopupContainerAttributes) => css`
    transition: transform ${FADE_DURATION}ms ${Ease.In.Sine},
      opacity ${OPACITY_DURATION}ms ${FADE_DURATION - OPACITY_DURATION}ms;

    transform: translate(-50%, -50%) scale(0.75);
    background: none;
    border: none;

    will-change: transform, opacity;
    backface-visibility: hidden;

    max-width: ${Screen.MAX};
    transform-origin: 50%;
    position: absolute;
    padding: 0px;

    max-height: 80vmax;
    min-width: 256px;

    display: block;
    height: auto;

    opacity: 0;
    margin: 0;

    left: 50%;
    top: 50%;

    ${width &&
    css`
      width: ${width}%;
    `}

    ${fullScreen &&
    css`
      max-height: 100vmax;
      border-radius: 0;

      height: 100vmax;
      width: 100vmin;
      border: none;
    `}
  `
);

export const PopupInner = styled.div(
  ({ background }: PopupContainerAttributes) => css`
    background-color: ${background ?? BACKGROUND_COLOR};

    border-radius: 16px;
    max-height: 90vmax;
    padding: 24px 16px;

    min-width: 256px;
    overflow: auto;
  `
);
